import React from 'react';
import PropTypes from 'prop-types';

import './three-essentails-button.scss';
import ImageAsset from '../image-asset/image-asset';

const ThreeEssentailsButton = ({ clickHandler, title, show3EIcon = true, buttonClassName, showArrow = true }) => (
    <button
        className={`three_essentials_button ${buttonClassName}`}
        onClick={clickHandler}
    >
        {show3EIcon && (
            <ImageAsset
                parentClass={'three_essentials_button__icon three_essentials_button__3e-icon'}
                type={'threeEssentials'} />
        )}
        {title}
        {showArrow && <ImageAsset parentClass={'three_essentials_button__icon'} type={'arrow'} />}
    </button>
);

ThreeEssentailsButton.propTypes = {
    clickHandler: PropTypes.func.isRequired,
    title: PropTypes.string,
    show3EIcon: PropTypes.bool,
    buttonClassName: PropTypes.string,
    showArrow: PropTypes.bool
};

export default ThreeEssentailsButton;



// WEBPACK FOOTER //
// ./components/three-essentails-button/three-essentails-button.js